import { Collapse, CollapseProps, Flex, Typography } from "antd";
import { useStores } from "stores";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { routes } from "constants/routes";
import { AddUserButton } from "components/AddUser";
import { isCompanyActive } from "interfaces";

export const CompanyUserList = observer(() => {
  const { companyUsers, companyCard, user } = useStores();
  const navigate = useNavigate();

  const { isUserAdmin } = user.roles;

  const showAddCompanyButton = isUserAdmin && isCompanyActive(companyCard.card.status);

  const collapseItem: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <Flex align="center">
          <Typography.Text strong className="whitebox-title">
            Пользователи
          </Typography.Text>
          {showAddCompanyButton && <AddUserButton isIconButton />}
        </Flex>
      ),
      children: (
        <Flex vertical gap="large">
          <CommonTable
            store={companyUsers}
            columns={getColumns(companyCard.card, user)}
            updateWithInterval
            onRow={(record) => ({
              onClick: () => {
                navigate(`/${routes.users}/${record.id}`);
              },
              className: "cursor-pointer",
            })}
          />
        </Flex>
      ),
    },
  ];

  return <Collapse items={collapseItem} bordered={false} expandIconPosition="end" />;
});
